export default "__VITE_ASSET__CN7X3Wl5__"